import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { map, head, tail, length, isEmpty, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Entity, DomainEntity, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { createElement } from "react";
import React from "react";
import { adminContent, ByCell, dateTimeCell, Labels, EntityName } from "./Prelude.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/Subsystems.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, MoveToSystem, Update } from "../Modals/Subsystem.fs.js";
import { Components_UnDelete, Components_Delete, Components_ChangeAttributes, Components_ChangeLabels } from "../Modals/Modal.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", detail]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function systemParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["systemId"]);
    }
    else {
        return new FSharpResult$2(0, [["systemId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("system", "System", new FilterType(1, [projectId, new DomainEntities(1, []), empty(), systemParam])), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(2, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, subsystem) {
    return new Row(subsystem.Id, ofArray([new Cell("name", subsystem.Name), new Cell("detail", subsystem.Detail), new Cell("system", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(1, []),
        entityId: subsystem.SystemId,
    })), new Cell("labels", createElement(Labels, {
        labels: subsystem.Labels,
    })), new Cell("lastModifiedOn", dateTimeCell(subsystem.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: subsystem.LastModifiedBy,
    }))]));
}

export function Subsystems(subsystemsInputProps) {
    let actions, subsystems, subsystems_1;
    const projectId = subsystemsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedSubsystems = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Subsystems",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (subsystemParams) => many(projectId, empty(), subsystemParams),
        fetchCount: (subsystemParams_1) => count(projectId, subsystemParams_1),
        rowRender: (subsystem) => rowRender(projectId, subsystem),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedSubsystems);
    const isMoreThan1 = length(selectedSubsystems) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Move To System"], ["onClick", (_arg_3) => {
        setAction("moveToSystem");
    }], ["disabled", isEmpty(selectedSubsystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_4) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedSubsystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Attributes"], ["onClick", (_arg_5) => {
        setAction("changeAttributes");
    }], ["disabled", isEmpty(selectedSubsystems) ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_6) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedSubsystems)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_7) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedSubsystems)]])))))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedSubsystems) ? (isEmpty(tail(selectedSubsystems)) ? createElement(Update, {
        projectId: projectId,
        subsystem: head(selectedSubsystems),
        close: close,
    }) : undefined) : undefined) : ((actions === "moveToSystem") ? createElement(MoveToSystem, {
        projectId: projectId,
        subsystems: selectedSubsystems,
        close: close,
    }) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map((subsystem_1) => [new DomainEntity(7, [subsystem_1]), subsystem_1.Labels], selectedSubsystems),
        close: close,
    }) : ((actions === "changeAttributes") ? createElement(Components_ChangeAttributes, {
        projectId: projectId,
        entities: map((subsystem_2) => [new Entity(6, [subsystem_2]), subsystem_2.Attributes], selectedSubsystems),
        close: close,
    }) : ((actions === "delete") ? ((subsystems = map((Item) => (new DomainEntity(7, [Item])), selectedSubsystems), createElement(Components_Delete, {
        projectId: projectId,
        entities: subsystems,
        close: close,
    }))) : ((actions === "unDelete") ? ((subsystems_1 = map((Item_1) => (new DomainEntity(7, [Item_1])), selectedSubsystems), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: subsystems_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    })))))))) : undefined);
}

